"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart(props) {
        return _super.call(this, props) || this;
    }
    Cart.prototype.render = function () {
        var _this = this;
        var data = this.props.data;
        var cart = this.context.state ? this.context.state.cart : false;
        return cart ? (React.createElement("button", { onClick: function () { return _this.props.toggleCart(); }, className: "relative flex items-center justify-center transition-fast text-arctic hover:text-charcoal focus:outline-none md:ml-3 no-underline" },
            React.createElement(Snippets.Svg, { name: "basket", width: 22, className: "block" }),
            cart.item_count > 0 ? (React.createElement("div", { className: "absolute bg-red h-1-9 w-1-9 rounded-full", style: { top: "-6px", right: "-12px" } },
                React.createElement("p", { className: (data.template && (data.template.name == "blog" || data.template.name == "article")
                        ? "ml-0-4 text-xs hidden md:block"
                        : "absolute text-center text-ms font-bold pin") + " mt-0" }, cart.item_count))) : null)) : null;
    };
    Cart.contextType = next_components_1.ShopifyNext.Context;
    return Cart;
}(React.PureComponent));
exports.Cart = Cart;
